import styled from 'styled-components/macro';
import { keyframes } from 'styled-components/macro';

const BlockFadeIn = keyframes`
    from {
        opacity: 0;
        display: none;
    } to {
        opacity: 1;
        display: block;
    } 
`;

const BlockFadeOut = keyframes`
    from {
        opacity: 1;
        display: block;    
    } to {
        opacity: 0;
        display: none;
    } 
`;

const SelectFadeIn = keyframes`
    from {
        opacity: 0;
        display: none;
    } to {
        opacity: 1;
        display: flex;
    } 
`;

const SelectFadeOut = keyframes`
    from {
        opacity: 1;
        display: flex;    
    } to {
        opacity: 0;
        display: none;
    } 
`;

export const getItemAnimation = (collapsed: boolean) => {
  return collapsed ? BlockFadeOut : BlockFadeIn;
};

export const getSelectAnimation = (collapsed: boolean) => {
  return collapsed ? SelectFadeIn : SelectFadeOut;
};

export const ActionItem = styled.div<{
  isSelected: boolean;
  isCollapsed: boolean;
}>`
  animation-name: ${(props) => getItemAnimation(props.isCollapsed)};
  animation-delay: 0s;
  animation-duration: 300ms;
  display: ${(props) => (props.isCollapsed && !props.isSelected ? 'none' : '')};
  padding: 12px;
  border-radius: 8px;
  box-shadow:
    0 1px 2px 0 rgba(15, 23, 40, 0.04),
    0 1px 3px 0 rgba(15, 23, 40, 0.12),
    0 0 8px 4px rgba(15, 23, 40, 0.04);
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  transition: all 150ms;
  text-align: center;
  background-color: #f2f5f8;
  border: 1px solid transparent;
  cursor: pointer;

  :hover {
    background-color: #e4e8ee;
  }
`;
